A SEEK work type code.

For positions in `seekAnz` scheme, this field is used instead of `positionScheduleTypeCodes`.

Currently, four codes are defined:

- `Casual` indicates a casual position.
- `ContractTemp` indicates a fixed-length contract position.
- `FullTime` indicates a full-time position.
- `PartTime` indicates a part-time position.

Scheme requirements:

- This field is required for the `seekAnz` scheme.
- Omit this field for other schemes.
